import { render, staticRenderFns } from "./ImageTextLinkSection.vue?vue&type=template&id=5b2e5d04"
import script from "./ImageTextLinkSection.vue?vue&type=script&lang=js"
export * from "./ImageTextLinkSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CornerIcon: require('/vercel/path0/components/icons/CornerIcon.vue').default,PlusIcon: require('/vercel/path0/components/icons/PlusIcon.vue').default,AppLink: require('/vercel/path0/components/shared/AppLink.vue').default})
